export class Paginated<T> {
	pageNumber: number = 1;
	pageSize: number = 0;
	totalPages: number = 0;
	totalRecords: number = 0;
	data: T[] = [];
}
